import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { getStatusPageData } from "./commons";
import { tooltipate } from "../index";
export const KNavbar = ({ className = "", statusPageComponentIds, dark = false, brand, children, rightMost }) => {
    const [statusPageData, setStatusPageData] = useState();
    useEffect(() => {
        let interval;
        async function callGetStatusPageData() {
            if (statusPageComponentIds) {
                statusPageComponentIds = statusPageComponentIds.length > 0 ? statusPageComponentIds : [""];
                let foundData = false;
                for (const statusPageComponentId of statusPageComponentIds) {
                    const data = await getStatusPageData(statusPageComponentId);
                    if (data) {
                        setStatusPageData(data);
                        foundData = true;
                        break;
                    }
                }
                if (!foundData) {
                    setStatusPageData(undefined);
                }
                interval = setTimeout(callGetStatusPageData, 60 * 1000);
            }
        }
        callGetStatusPageData().catch(console.error);
        return () => (interval ? clearInterval(interval) : undefined);
    }, []);
    return (_jsxs(Navbar, { bg: dark ? "dark" : "light", variant: dark ? "dark" : "light", expand: "lg", className: className, children: [_jsx(Nav, { children: brand }), _jsx(Navbar.Toggle, { "aria-controls": "k-navbar" }), _jsxs(Navbar.Collapse, { id: "k-navbar", children: [_jsx(Nav, { className: "me-auto", children: children }), _jsx(Nav, { children: rightMost }), statusPageData ? (_jsx(Nav, { children: tooltipate(_jsx("a", { href: statusPageData.url, target: "_blank", children: _jsx("i", { className: `fa fa-circle-exclamation text-${statusPageData.componentStatus}` }) }), statusPageData.name, "bottom") })) : null] })] }));
};
